/**
 * @description
 * Definicja typów bloków
 */
export enum BlockNodeEnum {
  /**
   * @description
   * Reprezentuje kontener <div>
   */
  DIV_NODE = 0,

  /**
   * @description
   * Reprezentuje paragraf <p>
   */
  PARAGRAPH_NODE = 1,

  /**
   * @description
   * Reprezentuje nagłówek <h>
   */
  HEADING_NODE = 2,

  /**
   * @description
   * Reprezentuje anchor <a>
   */
  ANCHOR_NODE = 3,

  /**
   * @description
   * Reprezentuje obraz <image>
   */
  IMAGE_NODE = 4,

  /**
   * @description
   * Reprezentuje linie poziomą
   */
  HORIZONTAL_LINE = 5,

  /**
   * @description
   * Reprezentuje linie pionową
   */
  VERTICAL_LINE = 6,

  /**
   * @description
   * Reprezentuje element nawigacyjny <nav>
   */
  NAV_NODE = 7,

  /**
   * @description
   * Reprezentuje element będący snippetem (różne tagi zależnie od tego co snippet zwróci)
   */
  SNIPPET_NODE = 8,

  /**
   * @description
   * Reprezentuje ikonkę
   */
  ICON_NODE = 9,

  /**
   * @description
   * Reprezentuje element input o typie text
   */
  INPUT_TEXT_NODE = 10,

  /**
   * @description
   * Reprezentuje element input o typie text
   */
  INPUT_SEARCH_NODE = 18,

  /**
   * @description
   * Reprezentuje element input o typie password
   */
  INPUT_PASSWORD_NODE = 11,

  /**
   * @description
   * Reprezentuje element input o typie checkbox
   */
  INPUT_CHECKBOX_NODE = 12,

  /**
   * @description
   * Reprezentuje element input o typie radio
   */
// INPUT_RADIO_NODE = 13,

  /**
   * @description
   * Reprezentuje kontener <div> w którym można umieścić jako tło plik wideo <video>
   */
  VIDEO_NODE = 14,

  /**
   * @description
   * Reprezentuje element textarea
   */
  TEXTAREA_NODE = 15,

  /**
   * @description
   * Reprezentuje element iframe
   */
  IFRAME_NODE = 16,

  /**
   * @description
   * Reprezentuje element svg
   */
  SVG_NODE = 17,
  /**
   * @description
   * Reprezentuje element svg
   */
  IFRAME_SCRIPT = 19,

  /**
   * @description
   * Reprezentuje rodzica iframe
   */
  IFRAME_PARENT = 20,

  /**
   * @description
   * Reprezentuje element input o typie file
   */
  INPUT_FILE_NODE = 21,

  /**
   * @description
   * Reprezentuje element select
   */
  SELECT_NODE = 22,
}

export const FORM_FIELD_NODES = [
  BlockNodeEnum.INPUT_TEXT_NODE,
  BlockNodeEnum.INPUT_PASSWORD_NODE,
  BlockNodeEnum.INPUT_CHECKBOX_NODE,
  BlockNodeEnum.INPUT_FILE_NODE,
  BlockNodeEnum.SELECT_NODE,
  BlockNodeEnum.INPUT_SEARCH_NODE,
  BlockNodeEnum.TEXTAREA_NODE,
];
